import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearPreventiveTasks,
  getPreventiveTaskAll,
} from '../../../../actions/task-schedule/PreventiveTask';

export const PreventiveTaskSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearPreventiveTasks,
  dispatchGetPreventiveTasks,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearPreventiveTasks(), []);

  const onInputChangePreventiveTask = (inputValue) => {
    const value = (inputValue || '').trim();
    const len = value.length;
    if (len < 1) return;

    const looksLikeId =
      !/\s/.test(value) && /\d/.test(value) && /^[A-Za-z0-9._-]+$/.test(value);

    const field = looksLikeId ? 'companyPreventiveTaskId' : 'name';

    dispatchGetPreventiveTasks({ query: [`${field}:${value}`] });
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangePreventiveTask}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

PreventiveTaskSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetPreventiveTasks: PropTypes.func.isRequired,
  dispatchClearPreventiveTasks: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  noOptionsMessage: PropTypes.func,
};

PreventiveTaskSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por código o nombre de tarea',
  noOptionsMessage: undefined,
};

const mapStateToProps = ({ TaskScheduleUnit }) => ({
  options: TaskScheduleUnit.PreventiveTask.getIn([
    'all',
    'content',
    'content',
  ]).map(({ companyPreventiveTaskId, id, name }) => ({
    value: id,
    label: `${companyPreventiveTaskId} - ${name}`,
  })),
  loading: TaskScheduleUnit.PreventiveTask.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetPreventiveTasks: getPreventiveTaskAll,
  dispatchClearPreventiveTasks: clearPreventiveTasks,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreventiveTaskSelect);
